function truthy(value: string | null | undefined): boolean {
    return !!value && value !== 'false' && value !== '0';
}

const _config = {
    isDebug: false,
}
const _defaultConfig = Object.freeze({..._config}); // freeze the default config to prevent accidental modifications

type ConfigKey = keyof typeof _config;
type TypeMapper = (val: string | null) => (boolean | number | string);
const typeMapping: { [key in ConfigKey]: TypeMapper } = {
    isDebug: truthy,
} satisfies Record<ConfigKey, TypeMapper>;
export const config: Readonly<typeof _config> = {
    get isDebug() {
        return _config.isDebug;
    },
}
const configKeys = Object.keys(_config) as ConfigKey[];

function getKey(key: ConfigKey) {
    return 'swss-' + ({
        isDebug: 'debug',
    }[key as string] || key.replace(/([A-Z])/g, '-$1').toLowerCase());
}

export function updateConfig(searchParams: URLSearchParams | Partial<Record<string, ReturnType<TypeMapper>>>) {
    const searchParamsIsObject = typeof searchParams === 'object' && !(searchParams instanceof URLSearchParams);
    configKeys.forEach(key => {
        const lookupKey = getKey(key);
        const value = searchParamsIsObject ? searchParams[lookupKey] : searchParams.get(lookupKey);
        if (value !== null && value !== undefined && key in _config && key in typeMapping) {
            try {
                (_config as Record<ConfigKey, ReturnType<TypeMapper>>)[key] = searchParamsIsObject ? value : typeMapping[key](value as string | null);
            } catch (error) {
                // Optimization: do not use warn() from log.ts
                console.warn('SaaS Web Spam Shield:', `Failed to convert value for config key: ${lookupKey}`, error);
            }
        }
    })
}

export function exportConfig() {
    const params = new URLSearchParams();
    configKeys.forEach(key => {
        if (_config[key] === _defaultConfig[key]) return; // skip default values
        params.set(getKey(key), String(_config[key]));
    });
    return params
}
